"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryType = exports.FeesSpreadUnit = exports.RetroCedingUnit = exports.LogisticRangeUnit = exports.TransporterRangeUnit = exports.RuleMethod = exports.RuleUnit = exports.RuleTarget = exports.FeesScheduleType = exports.LogisticDelayUnit = exports.LogisticRoute = void 0;
/** The main way the shipping will be delivered to customer */
var LogisticRoute;
(function (LogisticRoute) {
    LogisticRoute["ClickAndCollect"] = "click_and_collect";
    LogisticRoute["HomeDelivery"] = "home_delivery";
    LogisticRoute["PickupPoint"] = "pickup_point";
    LogisticRoute["StoreDelivery"] = "store_delivery";
})(LogisticRoute || (exports.LogisticRoute = LogisticRoute = {}));
var LogisticDelayUnit;
(function (LogisticDelayUnit) {
    LogisticDelayUnit["Hour"] = "hour";
    LogisticDelayUnit["Day"] = "day";
    LogisticDelayUnit["WorkingDay"] = "working_day";
    LogisticDelayUnit["Week"] = "week";
    LogisticDelayUnit["Month"] = "month";
})(LogisticDelayUnit || (exports.LogisticDelayUnit = LogisticDelayUnit = {}));
var FeesScheduleType;
(function (FeesScheduleType) {
    FeesScheduleType["Standard"] = "standard";
    FeesScheduleType["Advanced"] = "advanced";
})(FeesScheduleType || (exports.FeesScheduleType = FeesScheduleType = {}));
var RuleTarget;
(function (RuleTarget) {
    RuleTarget["LogisticOrder"] = "logistic_order";
    RuleTarget["Order"] = "order";
})(RuleTarget || (exports.RuleTarget = RuleTarget = {}));
var RuleUnit;
(function (RuleUnit) {
    RuleUnit["Euro"] = "euro";
    RuleUnit["Percent"] = "percent";
})(RuleUnit || (exports.RuleUnit = RuleUnit = {}));
var RuleMethod;
(function (RuleMethod) {
    RuleMethod["Increase"] = "increase";
    RuleMethod["Decrease"] = "decrease";
    RuleMethod["Equals"] = "equals";
})(RuleMethod || (exports.RuleMethod = RuleMethod = {}));
var TransporterRangeUnit;
(function (TransporterRangeUnit) {
    TransporterRangeUnit["WeightInG"] = "weightInG";
    TransporterRangeUnit["DimensionInMm"] = "dimensionInMm";
    TransporterRangeUnit["TotalConsignmentWeightInGrams"] = "totalConsignmentWeightInGrams";
    TransporterRangeUnit["LongestProductDimensionInMillimeters"] = "longestProductDimensionInMillimeters";
    TransporterRangeUnit["UnWrappedProductDimensionsInMillimeters"] = "unWrappedProductDimensionsInMillimeters";
})(TransporterRangeUnit || (exports.TransporterRangeUnit = TransporterRangeUnit = {}));
var LogisticRangeUnit;
(function (LogisticRangeUnit) {
    LogisticRangeUnit["WeightInG"] = "weightInG";
    LogisticRangeUnit["DimensionInMm"] = "dimensionInMm";
})(LogisticRangeUnit || (exports.LogisticRangeUnit = LogisticRangeUnit = {}));
var RetroCedingUnit;
(function (RetroCedingUnit) {
    RetroCedingUnit["EuroPerKg"] = "euroPerKg";
    RetroCedingUnit["EuroPerArticle"] = "euroPerArticle";
    RetroCedingUnit["Euro"] = "euro";
})(RetroCedingUnit || (exports.RetroCedingUnit = RetroCedingUnit = {}));
var FeesSpreadUnit;
(function (FeesSpreadUnit) {
    FeesSpreadUnit["Quantity"] = "quantity";
    FeesSpreadUnit["WeightInGrams"] = "weightInGrams";
})(FeesSpreadUnit || (exports.FeesSpreadUnit = FeesSpreadUnit = {}));
var DeliveryType;
(function (DeliveryType) {
    DeliveryType["Shipping"] = "shipping";
    DeliveryType["ClickAndCollect"] = "clickAndCollect";
})(DeliveryType || (exports.DeliveryType = DeliveryType = {}));
//# sourceMappingURL=data:application/json;base64,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